import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useAuth } from "../features/accounts/contexts/AuthContext";
import MapContainer from "../features/map/components/MapContainer";
import UploadingOverlay from "../components/UploadingOverlay";
import Loading from "../features/uiStatus/components/Loading";

function MapPage() {
    // DashboardPageからprojectを取得（重複呼び出しを防ぐ）
    const outletContext = useOutletContext();
    const projectFromContext = outletContext?.project;
    // AuthContextからuserを取得（重複呼び出しを防ぐ）
    const { user: userFromAuth } = useAuth();
    const [loginUser, setLoginUser] = useState(userFromAuth || null);
    const [center, setCenter] = useState(null);
    const [zoom, setZoom] = useState(15);
    const [isUploadingMedia, setIsUploadingMedia] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(null);

    useEffect(() => {
        if (projectFromContext) {
            if (projectFromContext.latitude && projectFromContext.longitude) {
                setCenter({ lat: projectFromContext.latitude, lng: projectFromContext.longitude });
            } else {
                console.error("緯度経度が取得できませんでした");
            }

            if (projectFromContext.zoom !== undefined && projectFromContext.zoom !== null) {
                setZoom(projectFromContext.zoom);
            }
        }
    }, [projectFromContext]);

    // AuthContextからuserを取得（重複呼び出しを防ぐ）
    useEffect(() => {
        if (userFromAuth) {
            setLoginUser(userFromAuth);
        }
    }, [userFromAuth]);

    const isReady = !!center && !!loginUser;

    if (!isReady) {
        return <Loading isLoading message="地図の読み込み中..." />;
    }

    return (
        <div className="fixed left-0 top-0 box-border mt-[var(--header-height)] flex h-[calc(100vh-var(--header-height))] w-screen flex-col overflow-hidden bg-bg-primary">
            {isUploadingMedia && (
                <UploadingOverlay 
                    totalFiles={uploadProgress?.totalFiles || 0}
                    completedFiles={uploadProgress?.completedFiles || 0}
                    currentFileName={uploadProgress?.currentFileName}
                    overallProgress={uploadProgress?.overallProgress || 0}
                />
            )}
            <main className="relative h-full min-w-0 w-full flex-1 overflow-hidden">
                <MapContainer
                    defaultCenter={center}
                    defaultZoom={zoom}
                    loginUser={loginUser}
                    project={projectFromContext}
                    setIsUploadingMedia={setIsUploadingMedia}
                    setUploadProgress={setUploadProgress}
                />
            </main>
        </div>
    );
}

export default MapPage;
